
import React from 'react';
import BackButton from '../components/BackButton';

const TermsOfServicePage: React.FC = () => {
    return (
        <div className="space-y-4">
            <BackButton text="Back to Settings" />
            <div className="bg-white p-4 rounded-lg shadow-sm space-y-2 text-sm">
                <h2 className="text-xl font-bold">Terms of Service</h2>
                <p><strong>Last Updated:</strong> 1st September 2025</p>
                <p>By downloading or using "What Was It?", you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access the service.</p>
                
                <h3 className="font-bold text-lg pt-2">1. Accounts</h3>
                <p>When you create an account with us, you agree to provide accurate information. You are responsible for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.</p>

                <h3 className="font-bold text-lg pt-2">2. User Conduct & Zero Tolerance Policy</h3>
                <p>We maintain a <strong>Zero Tolerance Policy</strong> for objectionable content and abusive users.</p>
                <p>You agree NOT to post content that is:</p>
                <ul className="list-disc list-inside pl-2 mt-1 space-y-1 text-gray-700">
                    <li><strong>Sexually Explicit:</strong> Pornography, nudity, or sexually suggestive material.</li>
                    <li><strong>Illegal:</strong> Content that promotes illegal acts or violates any law.</li>
                    <li><strong>Hateful:</strong> Hate speech, harassment, bullying, or threats of violence.</li>
                    <li><strong>Defamatory:</strong> Libelous or slanderous material.</li>
                </ul>
                <p className="mt-2">We reserve the right to remove any content and ban any user found violating these terms immediately and without notice.</p>
                
                <h3 className="font-bold text-lg pt-2">3. Intellectual Property & Copyrights</h3>
                <p>You retain ownership of the content you create. By posting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, and display that content in connection with the service.</p>
                <p className="mt-1 pb-1"><strong>Audio Content & DMCA:</strong> You must own the rights to or have permission to use any audio clips, music, or recordings you upload. We comply with the Digital Millennium Copyright Act (DMCA). Content found to infringe upon the copyright of others will be removed promptly, and the associated accounts may be suspended.</p>

                <h3 className="font-bold text-lg pt-2">4. Termination</h3>
                <p>We may terminate or suspend your account at any time, without prior notice or liability, for any reason, including if you breach these Terms.</p>
                
                <h3 className="font-bold text-lg pt-2">5. Disclaimer</h3>
                <p>The service is provided "AS IS," without warranty of any kind. We do not warrant that the app will be uninterrupted, secure, or error-free.</p>

                <h3 className="font-bold text-lg pt-2">6. Governing Law</h3>
                <p>These Terms shall be governed by the laws of the United Kingdom, without regard to its conflict of law provisions.</p>
            </div>
        </div>
    );
};

export default TermsOfServicePage;
